<template>
  <section v-if="step === 1" class="page-container">
    <Step1
      :step="step"
      :vehicles-data="vehicles"
      @vehicle-data="setVehicleData"
      @get-step="onChangeStep" />
  </section>
  <section v-if="step === 2" class="page-container">
    <Step2
      :step="step"
      :vehicles-data="vehicles"
      @customer-data="setCustomerData"
      @get-step="onChangeStep" />
  </section>
  <section v-if="step === 3">
    <Step3
      :step="step"
      :vehicles-data="vehicles"
      :customer-data="customerData"
      @get-step="onChangeStep" />
  </section>
</template>

<script>
import Step1 from './../components/quotation-request/Step1.vue'
import Step2 from './../components/quotation-request/Step2.vue'
import Step3 from './../components/quotation-request/Step3.vue'

export default {
  components: {
    Step1,
    Step2,
    Step3,
  },
  data() {
    return {
      vehicles: [],
      customerData: null,

      step: 1,
    }
  },
  computed: {},
  methods: {
    setVehicleData(data) {
      this.vehicles = data
    },
    setCustomerData(data) {
      this.customerData = data
    },
    onChangeStep(step, newRequest) {
      if (step === 1 && newRequest) {
        this.vehicles = []
        this.customerData = null
      }
      this.step = step
    },
  },
}
</script>
